/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import socket from '../socket';

const ChatOverlay = styled.div`
  position: fixed;
  top: 90px;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  z-index: 100;
  display: flex;
  flex-direction: column;
  transition: opacity 0.25s ease, visibility 0.25s ease;
  opacity: ${({ $display }) => ($display ? 1 : 0)};
  visibility: ${({ $display }) => ($display ? 'visible' : 'hidden')};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #e1e4e8;
  font-weight: 600;
  font-size: 18px;
  color: black;
`;

const CloseButton = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  color: #555;

  :hover {
    background-color: #f0f0f0;
  }
`;

const ChatArea = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
`;

const MessageList = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 15px;
  color: #454552;
`;

const Message = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  margin-top: 15px;
  margin-left: 15px;
  text-align: left;

  > strong {
    margin-left: 3px;
  }

  > p {
    max-width: 75%;
    width: auto;
    padding: 9px;
    margin-top: 3px;
    border: 1px solid rgb(78, 161, 211, 0.3);
    border-radius: 15px;
    box-shadow: 0px 0px 3px #4ea1d3;
    font-size: 14px;
  }
`;

const UserMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  font-size: 16px;
  margin-top: 15px;
  text-align: right;

  > strong {
    margin-right: 35px;
  }

  > p {
    max-width: 75%;
    width: auto;
    padding: 9px;
    margin-top: 3px;
    margin-right: 15px;
    border: 1px solid rgb(78, 161, 211, 0.3);
    border-radius: 15px;
    background-color: #4ea1d3;
    color: white;
    font-size: 14px;
    text-align: left;
  }
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid rgb(69, 69, 82, 0.25);
`;

const BottomInput = styled.input`
  flex: 1;
  padding: 15px;
  border: none;
  box-sizing: border-box;
  font-size: 15px;
  outline: none;
`;

const SendButton = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4ea1d3;
  font-size: 20px;
  cursor: pointer;
  flex-shrink: 0;

  :hover {
    color: #2a7db5;
  }

  * {
    pointer-events: none;
  }
`;

const Chat = ({ display, roomId, onClose }) => {
  const currentUser = sessionStorage.getItem('user');
  const [msg, setMsg] = useState([]);
  const messagesEndRef = useRef(null);
  const inputRef = useRef();

  useEffect(() => {
    socket.on('FE-receive-message', ({ msg, sender }) => {
      setMsg((msgs) => [...msgs, { sender, msg }]);
    });
  }, []);

  const scrollToBottom = () =>
    messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });

  useEffect(() => {
    scrollToBottom();
  }, [msg]);

  const sendMessageNow = () => {
    const msg = inputRef.current.value;
    if (msg) {
      socket.emit('BE-send-message', { roomId, msg, sender: currentUser });
      inputRef.current.value = '';
    }
  };

  const sendMessage = (e) => {
    if (e.key === 'Enter') {
      sendMessageNow();
    }
  };

  return (
    <ChatOverlay $display={display}>
      <Header>
        Czat grupowy
        <CloseButton onClick={onClose}>
          <i className="fas fa-times" />
        </CloseButton>
      </Header>
      <ChatArea>
        <MessageList>
          {msg &&
            msg.map(({ sender, msg }, idx) => {
              if (sender !== currentUser) {
                return (
                  <Message key={idx}>
                    <strong>{sender}</strong>
                    <p>{msg}</p>
                  </Message>
                );
              }
              return (
                <UserMessage key={idx}>
                  <strong>{sender}</strong>
                  <p>{msg}</p>
                </UserMessage>
              );
            })}
          <div style={{ float: 'left', clear: 'both' }} ref={messagesEndRef} />
        </MessageList>
      </ChatArea>
      <InputRow>
        <BottomInput
          ref={inputRef}
          onKeyUp={sendMessage}
          placeholder="Wiadomość..."
        />
        <SendButton onClick={sendMessageNow}>
          <i className="fas fa-paper-plane" />
        </SendButton>
      </InputRow>
    </ChatOverlay>
  );
};

export default Chat;
